<template>

  <Form @submit="onSubmit" :validation-schema="schema" class="space-y-4 text-gray-700 mx-5" @invalid-submit="onInvalidSubmit">

    <div class="container mx-auto max-w-7xl my-7 p-5 lg:p-8 lg:pr-10 bg-white bg-opacity-90 rounded-lg shadow-xl">

      <h1 class="font-bold text-center text-2xl">Acreditación de Disertantes</h1>
      <h1 class="font-bold text-center text-xl">Por favor complete el formulario</h1>

      <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-5">
        <div class="w-full px-2 md:w-3/12">
          <label class="block mb-1">Tipo de documento (*)</label>
          <Field name="tipoDocumento" v-slot="{ handleChange, handleBlur, value, errors }" v-model="formData.tipoDocumento">
            <Select @blur="handleBlur" @update:model-value="handleChange" :model-value="value" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && value !== undefined, 'input-error': errors.length > 0}" placeholder="Tipo de documento" class="input-base" :options="tiposDocumentos" optionLabel="descripcion" />
            <span class="text-sm text-red-500 p-error"><ErrorMessage name="tipoDocumento" /></span>
          </Field>
        </div>
        <div class="w-full px-2 md:w-3/12">
          <label class="block mb-1">Número (*)</label>
          <Field name="dni" v-slot="{ field, errors }" v-model="formData.dni">
            <InputText v-bind="field" type="text" @blur="validarDni" class="input-base" placeholder="Número de documento" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}" />
            <span class="text-sm text-red-500 p-error"><ErrorMessage name="dni" /></span>
          </Field>
        </div>
        <div class="w-full px-2 md:w-3/12">
          <label class="block mb-1">Nombre (*)</label>
          <Field name="nombre" v-slot="{ field, errors }" v-model="formData.nombre">
            <InputText v-bind="field" type="text" class="input-base" placeholder="Nombre" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}" />
            <span class="text-sm text-red-500 p-error"><ErrorMessage name="nombre" /></span>
          </Field>
        </div>
        <div class="w-full px-2 md:w-3/12">
          <label class="block mb-1">Apellido (*)</label>
          <Field name="apellido" v-slot="{ field,errors }" v-model="formData.apellido">
            <InputText v-bind="field" type="text" class="input-base" placeholder="Apellido" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}" />
            <span class="text-sm text-red-500 p-error"><ErrorMessage name="apellido" /></span>
          </Field>
        </div>
      </div>

      <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
        <div class="w-full px-2 md:w-3/12">
            <label class="block mb-1">País</label>
            <Select v-model="selectedCountry" filter :options="paises" optionLabel="value" placeholder="Select a Country" class="input-base"/>
        </div>
        <div class="w-full px-2 md:w-2/12">
          <label class="block mb-1">Prefijo</label>
          <InputText type="text" v-if="selectedCountry !== null" v-model="selectedCountry.code" class="input-base" readonly />
        </div>
        <div class="w-full px-2 md:w-3/12">
          <label class="block mb-1">Código de área</label>
          <Field name="codigoArea" v-slot="{ field, errors }" v-model="formData.codigoArea">
            <InputText v-bind="field" type="text" class="input-base" placeholder="Código de área" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}"  />
            <span class="text-sm text-red-500 p-error"><ErrorMessage name="codigoArea" /></span>
          </Field>
        </div>
        <div class="w-full px-2 md:w-4/12">
          <label class="block mb-1">Teléfono</label>
          <Field name="numeroTelefono" v-slot="{ field, errors }" v-model="formData.numeroTelefono">
            <InputText v-bind="field" type="text" class="input-base" placeholder="Teléfono" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}" />
            <span class="text-sm text-red-500 p-error"><ErrorMessage name="numeroTelefono" /></span>
          </Field>
        </div>
      </div>

      <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-4">
        <div class="w-full px-2 md:w-6/12">
          <label class="block mb-1">Mail (*)</label>
          <Field name="mail" v-slot="{ field, errors }" v-model="formData.mail">
            <InputText v-bind="field" type="mail" class="input-base" placeholder="Mail" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}" />
            <span class="text-sm text-red-500 p-error"><ErrorMessage name="mail" /></span>
          </Field>
        </div>
        <div class="w-full px-2 md:w-6/12">
          <label class="block mb-1">Institución / Organismo que representa (*)</label>
          <Field name="institucion" v-slot="{ field, errors }" v-model="formData.institucion">
            <InputText v-bind="field" type="text" class="input-base" placeholder="Institución / Organismo" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}" />
            <span class="text-sm text-red-500 p-error"><ErrorMessage name="institucion" /></span>
          </Field>
        </div>
      </div>

      <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-4">
        <div class="w-full px-2 md:w-6/12">
          <label class="block mb-1">Cargo / Título (*)</label>
          <Field name="cargo" v-slot="{ field, errors }" v-model="formData.cargo">
            <InputText v-bind="field" type="text" class="input-base" placeholder="Cargo / Título" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}" />
            <span class="text-sm text-red-500 p-error"><ErrorMessage name="cargo" /></span>
          </Field>
        </div>
        <div class="w-full px-2 md:w-6/12">
          <label class="block mb-1">Actividad en la que participa (*)</label>
          <Field name="actividadDisertante" v-slot="{ field, errors }" v-model="formData.actividadDisertante">
            <InputText v-bind="field" type="text" class="input-base" placeholder="Actividad en la que participa" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}" />
            <span class="text-sm text-red-500 p-error"><ErrorMessage name="actividadDisertante" /></span>
          </Field>
        </div>
      </div>
      
      <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-4">
        <div class="w-full px-2 md:w-3/12">
          <label class="block mb-1">Horario de disertación (*)</label>
          <Field name="horarioDisertacion" v-slot="{ field, errors }" v-model="formData.horarioDisertacion">
            <InputText v-bind="field" type="text" class="input-base" placeholder="Horario de disertación" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}" />
            <span class="text-sm text-red-500 p-error"><ErrorMessage name="horarioDisertacion" /></span>
          </Field>
        </div>
        <div class="w-full px-2 md:w-3/12">
          <label class="block mb-1">¿Requiere equipo técnico especial? (*)</label>
          <Field name="requiereEquipoTecnico" v-slot="{ handleChange, handleBlur, value, errors }" v-model="formData.requiereEquipoTecnico">
            <Select @blur="handleBlur" @update:model-value="handleChange" :model-value="value" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && value !== undefined, 'input-error': errors.length > 0}" placeholder="Seleccione una opción" class="input-base" :options="opcionesSiNo" optionLabel="descripcion" />
            <span class="text-sm text-red-500 p-error"><ErrorMessage name="requiereEquipoTecnico" /></span>
          </Field>
        </div>
        <div class="w-full px-2 md:w-6/12">
          <label class="block mb-1">Detalle del equipo técnico</label>
          <Field name="equipoTecnico" v-slot="{ field, errors }" v-model="formData.equipoTecnico">
            <InputText v-bind="field" type="text" class="input-base" placeholder="Equipo técnico" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}" />
            <span class="text-sm text-red-500 p-error"><ErrorMessage name="equipoTecnico" /></span>
          </Field>
        </div>
      </div>

      <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-4">
        <div class="w-full px-2 md:w-12/12">
          <label class="block mb-1">Breve biografía (*)</label>
          <Field name="biografia" v-slot="{ field, errors }" v-model="formData.biografia">
            <Textarea v-bind="field" type="text" class="input-base" placeholder="Breve biografía" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}" />
            <span class="text-sm text-red-500 p-error"><ErrorMessage name="biografia" /></span>
          </Field>
        </div>
      </div>

      <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-4">
        <div class="w-full px-2 md:w-3/12">
          <label class="block mb-1">¿Asiste con un acompañante? (*)</label>
          <Field name="conAcompaniante" v-slot="{ handleChange, handleBlur, value, errors }" v-model="formData.conAcompaniante">
            <Select @blur="handleBlur" @update:model-value="handleChange" :model-value="value" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && value !== undefined, 'input-error': errors.length > 0}" placeholder="Seleccione una opción" class="input-base" :options="opcionesSiNo" optionLabel="descripcion" />
            <span class="text-sm text-red-500 p-error"><ErrorMessage name="conAcompaniante" /></span>
          </Field>
        </div>  
        <div class="w-full px-2 md:w-3/12">
          <label class="block mb-1">DNI del acompañante</label>
          <Field name="dniAcompaniante" v-slot="{ field, errors }" v-model="formData.dniAcompaniante">
            <InputText v-bind="field" type="text" class="input-base" placeholder="DNI del acompañante" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}" />
            <span class="text-sm text-red-500 p-error"><ErrorMessage name="dniAcompaniante" /></span>
          </Field>
        </div>
        <div class="w-full px-2 md:w-6/12">
          <label class="block mb-1">Nombre completo del acompañante</label>
          <Field name="nombreAcompaniante" v-slot="{ field, errors }" v-model="formData.nombreAcompaniante">
            <InputText v-bind="field" type="text" class="input-base" placeholder="Nombre completo del acompañante" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}" />
            <span class="text-sm text-red-500 p-error"><ErrorMessage name="nombreAcompaniante" /></span>
          </Field>
        </div>
      </div>    

      <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-8">
        <div class="w-full px-2">
          <a @click="isFileUploadVisible = true" class="w-full bg-[#175c8c] hover:bg-[#0f3449] hover:to-black text-white px-5 py-3 rounded-md transition-all duration-200 cursor-pointer">
            <i class="pi pi-upload"></i>
            SUBIR FOTO
          </a>
        </div>
      </div>

      <div class="flex flex-wrap py-2 mt-3">
        <button type="submit" label="REGISTRARME"
          class="mt-8 bg-[#175c8c] hover:bg-[#0f3449] hover:to-black text-white px-4 py-2 rounded-md transition-all duration-200"
          :disabled="isSubmitting">
          <i v-show="isSubmitting" class="pi pi-spin pi-spinner mr-2"></i>
          <i v-show="!isSubmitting" class="pi pi-check mr-2"></i> REGISTRARME
        </button>
      </div>
    </div>

    
  </Form>

  <FullScreenLoader :visible="isSubmitting" />

  <ModalFileUpload :visible="isFileUploadVisible" :askDescription="false" :forceSquare="false" :maxSizeMB="2"
    :fileTypes="['image/png', 'image/jpg', 'image/jpeg']" :onAccept="onFileUploadAcepted"
    @update:visible="isFileUploadVisible = $event" />
  <CropperView v-if="showCropper" :image="beforeCropBase64" @close="onCropFinished" />

</template>

<script lang="ts">
import * as yup from 'yup';
import { defineComponent } from 'vue';
import { Field, Form, ErrorMessage } from 'vee-validate';
import Swal from 'sweetalert2'

import InputText from 'primevue/inputtext';
import Select from 'primevue/select';
import Textarea from 'primevue/textarea';

import jsonCountries from '@/data/countries.json';

import suiteService, { Acreditado, ArchivoAcreditado, EstadoAcreditado, OrigenAcreditado, StringIdLabelEntity, TipoAcreditado, TipoArchivo } from 'qreventos-suite/services';

import {  SAVE, ORIGEN_ACREDITADO, A_VERIFICAR, TIPO_ARCHIVO_FOTO } from "qreventos-suite/constantes";
import suiteConfig from '@/services/suite.config';
import FullScreenLoader from '@/components/FullScreenLoader.vue';

import jsonTiposDocumentos from '@/data/tiposDocumentos.json';
import jsonOpcionesSiNo from '@/data/sino.json';
import ModalFileUpload from '@/components/commons/ModalFileUpload.vue';
import CropperView from '@/components/commons/CropperView.vue';

interface TipoDocumento extends StringIdLabelEntity {}
interface OpcionSiNo extends StringIdLabelEntity { }

interface Pais {
  code: string;
  value: string;
}

export default defineComponent({
  name: 'FormSection',
  components: {
    ModalFileUpload, CropperView,
    InputText, Select, Textarea,
    Field, ErrorMessage, Form, FullScreenLoader
  },
  data() {
    return {
      isSubmitting: false,
      paises: jsonCountries as Pais[],
      selectedCountry: { "code": "+54", "value": "Argentina" } as Pais,
      tiposDocumentos: jsonTiposDocumentos as TipoDocumento[],
      opcionesSiNo: jsonOpcionesSiNo as OpcionSiNo[],

      isFileUploadVisible: false,
      beforeCropBase64: '',
      showCropper: false,
      fotoBase64: '',
      fotoFileName: '',

      formData: {  
        tipoDocumento: undefined as unknown as TipoDocumento,
        dni: '',
        nombre: '',
        apellido: '',
        mail: '',
        codigoArea: '',
        numeroTelefono: '',
        institucion: '',
        cargo: '',
        actividadDisertante: '',
        horarioDisertacion: '',
        requiereEquipoTecnico: undefined as unknown as OpcionSiNo,
        equipoTecnico: '',
        biografia: '',
        conAcompaniante: undefined as unknown as OpcionSiNo,
        dniAcompaniante: '',
        nombreAcompaniante: '',

      }
    };
  }, 
  created () {
    document.title = "Cumbre federal de logísitca 2026";
  },
  computed: {
    schema() {
      return yup.object({
        tipoDocumento: yup.object().required("Seleccione una opción"),
        dni: yup.string().required("Ingrese el documento").min(6, "Al menos 6 caracteres"),
        nombre: yup.string().required("Ingrese el nombre").min(3, "Al menos 3 caracteres"),
        apellido: yup.string().required("Ingrese el apellido").min(3, "Al menos 3 caracteres"),
        mail: yup.string().required("Ingrese el mail").email("Mail inválido"),
        institucion: yup.string().required("Ingrese la institución").min(3, "Al menos 3 caracteres"),
        cargo: yup.string().required("Ingrese el cargo").min(3, "Al menos 3 caracteres"),
        actividadDisertante: yup.string().required("Ingrese la actividad").min(3, "Al menos 3 caracteres"),
        horarioDisertacion: yup.string().required("Ingrese el horario").min(3, "Al menos 3 caracteres"),
        requiereEquipoTecnico: yup.object().required("Seleccione una opción"),
        biografia: yup.string().required("Ingrese una breve biografía").min(30, "Al menos 30 caracteres"),
        conAcompaniante: yup.object().required("Seleccione una opción"),

        equipoTecnico: yup.mixed().test('validacion-equipo', 'Ingrese el equipo técnico', function(value) {
          const requiereEquipoTecnico = this.parent.requiereEquipoTecnico;     
          if(requiereEquipoTecnico?.id == 'SI' && !value) {
              return false;
          }
          return true;
        }),

        dniAcompaniante: yup.mixed().test('validacion-acompaniante', 'Ingrese el DNI del acompañante', function(value) {
          const conAcompaniante = this.parent.conAcompaniante;
          if(conAcompaniante?.id == 'SI' && !value) {
              return false;
          }
          return true;
        }),
        nombreAcompaniante: yup.mixed().test('validacion-acompaniante', 'Ingrese el nombre del acompañante', function(value) {
          const conAcompaniante = this.parent.conAcompaniante;
          if(conAcompaniante?.id == 'SI' && !value) {
              return false;
          }
          return true;
        }),
      });
        
    },
  },
  methods: {
    async onFileUploadAcepted(base64: string, fileName: string) {
      //const base64Splited:string = base64.split(',')[1];
      this.fotoFileName = new Date().getTime() + "_" + fileName.replace(/[^a-zA-Z0-9.]/g, '');
      this.beforeCropBase64 = base64;
      this.showCropper = true;

    },
    async onCropFinished(croppedBase64:string) {
      this.showCropper = false
      if (!croppedBase64) {
        return
      }
      
      const base64Splited = croppedBase64.split(',')[1]
      this.fotoBase64 = base64Splited
    },        
    onInvalidSubmit(values: any) {
      const errores: number = Object.values(values?.errors || {}).flat().length;
      console.log(values);
      console.log(errores);
      Swal.fire({ title: "Hay errores", html: "Por favor revise el formulario (" + errores + "error/es)", icon: "error"});
    },
    async validarDni() {
      try {
        if (this.formData.dni) {
          this.isSubmitting = true;
          let acreditadoExistente: Acreditado = await suiteService.findAcreditadoByFilters(suiteConfig.evento, "dni=" + this.formData.dni) as Acreditado;
          if (acreditadoExistente) {
            this.isSubmitting = false;
            Swal.fire({ title: "¡Atención!", html: "Ya estas registrado con este documento", icon: "warning" });
            return;
          }
        }
      } catch (error) {
        this.isSubmitting = false;
        Swal.fire({ title: "Error", text: error + '', icon: "error" });
      } finally {
        this.isSubmitting = false;
      }
    },
    async onSubmit() {
      this.isSubmitting = true;

      try {
        let acreditadoExistente:Acreditado[] =  await suiteService.findAcreditadosByFilters(suiteConfig.evento, "dni="+encodeURIComponent(this.formData.dni) ) ;
        if (acreditadoExistente.length > 0) {
            this.isSubmitting = false;
              Swal.fire({ title: "El DNI ingresado ya fue registrado",  html: "Estimado/a: hemos recibido sus datos con éxito.<br/><br/>Le enviamos un mail para informarle el estado de su registración. <br/><br/>Por favor revise su casilla de correo y de spam.", icon: "warning" }).then(() => {
                  this.isSubmitting = false;
              });
              return;
        }

        if (!this.fotoBase64) {
          this.isSubmitting = false;
          Swal.fire({ title: "¡Atención!", html: "Debe subir una foto personal", icon: "warning" });
          return;
        }

        const acreditado:Acreditado = {} as Acreditado;
        
        acreditado.tipoAcreditado = { "id" : 2638 } as TipoAcreditado,
        acreditado.estadoAcreditado = { "id": A_VERIFICAR } as EstadoAcreditado;
        acreditado.origenAcreditado = { "id": ORIGEN_ACREDITADO } as OrigenAcreditado;
        acreditado.dato5 = this.formData.tipoDocumento?.id;
        acreditado.dni = this.formData.dni;
        acreditado.nombre = this.formData.nombre;
        acreditado.apellido = this.formData.apellido;        
        acreditado.mail = this.formData.mail;
        acreditado.telefono = this.selectedCountry.code + this.formData.codigoArea + this.formData.numeroTelefono;
        acreditado.cargo = this.formData.cargo;
        acreditado.dato9 = this.formData.institucion;
        acreditado.dato10 = this.formData.actividadDisertante;
        acreditado.dato11 = this.formData.horarioDisertacion;
        acreditado.dato12 = this.formData.requiereEquipoTecnico?.id; 
        acreditado.dato13 = this.formData.equipoTecnico;
        acreditado.dato14 = this.formData.biografia;
        acreditado.dato15 = this.formData.conAcompaniante?.id;
        acreditado.dato16 = this.formData.dniAcompaniante;
        acreditado.dato17 = this.formData.nombreAcompaniante;
        acreditado.cantidad = 1;
        acreditado.notificar = true;
        acreditado.modificado = SAVE;

        acreditado.archivosAcreditado = [];

        const archivoAcreditado:ArchivoAcreditado = {} as ArchivoAcreditado;
        archivoAcreditado.tipoArchivo = { "id" : TIPO_ARCHIVO_FOTO } as TipoArchivo;
        archivoAcreditado.descripcion = "LICENCIA";
        archivoAcreditado.fileName = this.fotoFileName;
        archivoAcreditado.fileDataBase64 = this.fotoBase64;
        acreditado.archivosAcreditado.push(archivoAcreditado);

        const acreditadoActualizado: Acreditado = await suiteService.saveOrUpdate(suiteConfig.evento, acreditado);

    
        if (acreditadoActualizado) {
          this.isSubmitting = false;
          Swal.fire({ title: "¡Atención!",  html: "Hemos recibido sus datos con éxito.<br/><br/>Le enviamos un mail para informarle el estado de su registración.<br/><br/>Por favor revise su casilla de correo y de spam.", icon: "info" }).then(() => {
            this.$router.go(0);
          });
        }
      } catch (error) {
        this.isSubmitting = false;
        Swal.fire({ title: "Error", text: error + '', icon: "error" });
      }
    },
  }
});
</script>